@if(isVisible()){
<div [id]="navLink.id" class="udex-grid udex-mx-auto">
  <h2 class="heading__regular--l text-center udex-mb-16">
    {{ 'productDetails.benefitsAndFeatures' | cxTranslate }}
  </h2>


  @if(hasBenefits){
  <div class="d-flex flex-column" data-cy="benefits-wrapper">

    <h3 class="heading__regular--xxs text-blue-gray col-12 col-md-7 udex-mx-auto udex-mb-16"
      data-cy="features-and-benefits">
      {{ 'productDetails.benefits' | cxTranslate }}
    </h3>

    @for(benefit of limitedBenefits; track $index){
    <div class="col-12 col-md-7 udex-mx-auto udex-mb-12" data-cy="benefit-entry">
      <h4 class="heading__regular--xxs udex-mb-8">{{ benefit.headline }}</h4>
      <dcp-limited-text [charLimit]="300" [text]="benefit.text"></dcp-limited-text>
    </div>
    }

    @if(benefitsExceedsLimit){
    <udex-link (click)="toggleBenefits()" (keydown)="toggleBenefitsWithKeyboard($event)"
      class="d-block col-12 col-md-7 udex-mx-auto udex-mb-16" design="Default" accessible-role="Link">
      {{ (benefitsExtended ? 'productDetails.lessBenefits' : 'productDetails.moreBenefits') | cxTranslate }}
    </udex-link>
    }
  </div>
  }

  @if(hasFeatures){
  <div class="d-flex flex-column" data-cy="features-wrapper">
    @for(feature of limitedFeatures; track $index){

    <div [class.udex-pt-32]="hasBenefits" class="w-100 separator udex-mb-32" data-cy="feature-entry"></div>

    <div [class.flex-row-reverse]="feature.media?.length && !feature.media[0]?.right"
      class="row align-content-center justify-content-center">

      <div [class.col-md-5]="feature.media?.length && feature.media[0].url"
        [class.col-md-6]="!feature.media?.length || !feature.media[0].url"
        [class.ms-md-7]="feature.media?.length && !feature.media[0]?.right && feature.media[0].url"
        [class.me-md-7]="feature.media?.length && feature.media[0]?.right"
        class="col-12 d-flex flex-column justify-content-center px-0">
        <h4 class="heading__regular--xxs udex-mb-8">{{ feature.headline }}</h4>
        <dcp-limited-text [charLimit]="300" [text]="feature.text"></dcp-limited-text>
      </div>

      @if(feature.media && feature.media.length > 0){
      <div [class.features-media]="isImageFormat(feature.media[0].format)"
        class="mt-5 mt-md-0 col-12 col-sm-8 col-md-5 d-flex align-items-center px-0">
        <dcp-media [media]="feature.media[0]"></dcp-media>
      </div> }
    </div>
    }

    @if(featuresExceedsLimit){
    <udex-link (click)="toggleFeatures()" (keydown)="toggleFeaturesWithKeyboard($event)"
      class="d-block col-12 col-md-7 udex-mx-auto udex-mb-16" design="Default" accessible-role="Link">
      {{ (featuresExtended ? 'productDetails.lessFeatures' : 'productDetails.moreFeatures') | cxTranslate }}
    </udex-link>
    }

  </div>
  }
</div>

<div class="udex-legacy-shadow udex-my-32"></div>
}
